<script lang="ts" setup>
export interface Props {
  prices: {
    finalPrice?: string | number
    regularPrice: string | number
  }
}

const props = defineProps<Props>()

const { storeConfig, fetchStoreData } = useStore()
await fetchStoreData()

const price = computed<number>(() => {
  const propPrice = props.prices?.finalPrice ?? props.prices?.regularPrice
  if (typeof propPrice !== 'number') {
    return parseInt(propPrice, 10)
  }
  return propPrice
})

const canShow = computed<boolean>(() => price.value >= storeConfig.value?.in3_min_order_total && price.value <= storeConfig.value?.in3_max_order_total)

const priceIn3 = computed(() => {
  return {
    regularPrice: price.value / 3,
    finalPrice: null,
  }
})
</script>

<template>
  <div
    v-if="canShow"
    class="payin3"
  >
    <i18n-t keypath="Or in 3 installments of {price}">
      <template #price>
        <UiPrice
          v-if="priceIn3"
          :prices="priceIn3"
        />
      </template>
    </i18n-t>&nbsp;

    <NuxtIcon name="icon:payment-methods-payin3" />
  </div>
</template>

<style>
.payin3 {
  align-items: center;
  display: flex;

  .iconify {
    aspect-ratio: 2609 / 1645;
    margin-left: 0.8rem;
    height: 1lh;
    width: auto;
  }
}
</style>
